// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1GnTQ","calendarButtons":"ClockData_calendarButtons__RjvdB"};